import { render, staticRenderFns } from "./InspectionDetails.vue?vue&type=template&id=9fd630b6&scoped=true"
import script from "./InspectionDetails.vue?vue&type=script&lang=js"
export * from "./InspectionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd630b6",
  null
  
)

export default component.exports